module.exports = __webpack_public_path__ + "static/img/hzhb3.f30cb25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzhb3.png
// module id = /QDt
// module chunks = 0